import {Component, inject, OnInit} from '@angular/core';
import {IonContent} from '@ionic/angular/standalone';
import {HeaderComponent} from '../../common/header/header.component';
import {LanguageService} from '../../core/language.service';
import {FooterComponent} from '../../common/footer/footer.component';

@Component({
  selector: 'app-cookies-policy',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss'],
  imports: [
    IonContent,
    HeaderComponent,
    FooterComponent
  ]
})
export class CookiesPolicyComponent  implements OnInit {

  languageService: LanguageService = inject(LanguageService);
  constructor() { }

  ngOnInit() {}

}
